import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import * as S from "./Styled";
import useCategoryList from "../../hooks/useCategoryList";
import Category from "../../assets/Icons/Category";
import { categoryIcons } from "../../constants/Category/category-icons";
import { seasonalCategoryIcons } from "../../constants/Category/seasonal-icons"; 

const Categorias = () => {
  const { categoryRegularList, categorySeasonalList, categoryProductList} = useCategoryList();
  const gridCategorie = (categorieList, iconMap) => {
    return categorieList.map((categorie) => (
      <Category key={categorie.id} categorie={categorie} iconMap={iconMap} />
    ));
  };
  return (
    <div>
      <NavBar/> 
      <S.StoreBox>
        <S.TitleBox>
          <S.Title>Categorias</S.Title>
        </S.TitleBox>           
        <S.CategoryGrid>
          {gridCategorie(categoryRegularList, categoryIcons)}
        </S.CategoryGrid>
      </S.StoreBox>
      <S.StoreBox>
        <S.TitleBox>
          <S.Title>Páginas Sazonais</S.Title>
        </S.TitleBox>           
        <S.CategoryGrid>
          {gridCategorie(categorySeasonalList, seasonalCategoryIcons)}
        </S.CategoryGrid>
      </S.StoreBox>
      <S.StoreBox>
        <S.TitleBox>
          <S.Title>Páginas de Produto</S.Title>
        </S.TitleBox>           
        <S.CategoryGrid>
          {gridCategorie(categoryProductList, seasonalCategoryIcons)}
        </S.CategoryGrid>
      </S.StoreBox>
      <Footer/>
    </div>
  )
}

export default Categorias